<template>
  <div>
    <header class="header">
      <section class="header-top">
        <div class="left" v-show="goBack" @click="$router.go(-1)">
          <img src="./images/fanhui@2x.png" alt="">
        </div>
        <div class="title" v-show="headTitle">
          <span>{{headTitle}}</span>
        </div>
        <div class="right text" v-show="rightTitle" @click="goDetail">
          <span>{{rightTitle}}</span>
        </div>
        <!-- 论坛列表头部 发布 -->
        <a href="/message/Topic" class="right text" v-show="publish">
          <span>{{publish}}</span>
        </a>
        <!--<div class="right text" v-show="publish" @click="goPublish">
          <span>{{publish}}</span>
        </div>-->
        <!--邻里闲置头部 发布-->
        <a v-if="weixinShow" href="/publish/PublishIdle" class="right text" v-show="unusedPublish">
          <span>{{unusedPublish}}</span>
        </a>
        <div v-if="ordinaryShow" @click="goDinary" class="right text" v-show="unusedPublish">
          <span>{{unusedPublish}}</span>
        </div>
        <!-- <div class="right text" v-show="unusedPublish" @click="goUnusedPublish">
           <span>{{unusedPublish}}</span>
         </div>-->
        <div class="right text" v-show="choseCity" @click="goChose">
          <span>{{choseCity}}</span>
        </div>
        <!--物业报修列表 头部-->
        <a href="/publish/Repair" class="right text" v-show="repairsPublish">
          <span>{{repairsPublish}}</span>
        </a>
        <!--<div class="right text" v-show="repairsPublish" @click="goRepairsPublish">-->
        <!--<span>{{repairsPublish}}</span>-->
        <!--</div>-->
        <!-- 房屋列表头部 发布微信端 -->
        <a v-if="weixinShow" href="/publish/ToRent" class="right text" v-show="housePub">
          <span>{{housePub}}</span>
        </a>
        <!--房屋列表头部 发布普通浏览器端-->
        <div v-if="ordinaryShow" @click="goDinary" class="right text" v-show="housePub">
          <span>{{housePub}}</span>
        </div>
        <!-- <div class="right text" v-show="housePub" @click="goHousePub">
          <span>{{housePub}}</span>
        </div> -->
        <div class="right text" v-show="housePublish" @click="goHousePublish">
          <span>{{housePublish}}</span>
        </div>
        <div class="right text" v-show="goodsPublish" @click="gogoodsPublish">
          <span>{{goodsPublish}}</span>
        </div>
        <div class="right text" v-show="helpPublish" @click="gohelpPublish">
          <span>{{helpPublish}}</span>
        </div>
        <!--邻里求助列表 头部发布微信-->
        <a v-if="weixinShow" href="/publish/Help" class="right text" v-show="seekPublish">
          <span>{{seekPublish}}</span>
        </a>
        <!--邻里求助列表 头部发布普通浏览器-->
        <div v-if="ordinaryShow" @click="goDinary" class="right text" v-show="seekPublish">
          <span>{{seekPublish}}</span>
        </div>
        <!-- <div class="right text" v-show="seekPublish" @click="goseekPublish">
           <span>{{seekPublish}}</span>
         </div>-->
        <div class="right text" v-show="repairPublish" @click="gorepairPublish">
          <span>{{repairPublish}}</span>
        </div>
        <div class="right text" v-show="topicPublish" @click="gotopicPublish">
          <span>{{topicPublish}}</span>
        </div>
        <!--维护监理列表头部 发布-->
        <a href="/Release" class="right text" v-show="release">
          <span>{{release}}</span>
        </a>
        <!--<div class="right text" v-show="release" @click="goRelease">-->
        <!--<span>{{release}}</span>-->
        <!--</div>-->
        <div class="right text" v-show="torelease" @click="gotoRelease">
          <span>{{torelease}}</span>
        </div>
        <!-- <div class="right text" v-show="teamlist" @click="goTeamlist">
          <span>{{teamlist}}</span>
        </div> -->
        <a href="/Clocked" class="right text" v-show="teamlist">
          <span>{{teamlist}}</span>
        </a>
        <!-- <div class="right text" v-if="btnSubmit">
         <span>{{btnSubmit}}</span>
       </div> -->
        <!--监理列表头部 发布-->
        <!-- <a href="/CheckPublish" class="right text" v-show="check">
          <span>{{check}}</span>
        </a> -->
        <div class="right text" v-show="check" @click="goCheck">
          <span>{{check}}</span>
        </div>
        <div class="right text" v-show="checkPublish" @click="goCheckPublish">
          <span>{{checkPublish}}</span>
        </div>
        <div class="right text" v-show="recheckPublish" @click="goReCheckPublish">
          <span>{{recheckPublish}}</span>
        </div>
        <div class="right text" v-show="publishAllCheck" @click="goPublishAllCheck">
          <span>{{publishAllCheck}}</span>
        </div>
        <div class="right text" v-show="editCheck" @click="goEditAllCheck">
          <span>{{editCheck}}</span>
        </div>
      </section>
    </header>
  </div>
</template>
<style lang="scss">
  .header {
    top: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 666;
    height: 40px;
    line-height: 40px;
    background-color: #0B7AD9;
    .header-top {
      position: relative;
      .title {
        text-align: center;
        margin: 0 auto;
        font-size: 17px;
        color: #fff;
        width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .left {
        position: absolute;
        top: 0;
        left: 0;
        width: 28px;
        height: 40px;
        padding: 0 10px;
        img {
          width: 9px;
          height: 16px;
          font-size: 0;
          vertical-align: middle;
        }
      }
      .right {
        position: absolute;
        top: -10px;
        right: 0;
        padding: 10px 10px 0 10px;
        img {
          height: 9px;
          width: 16px;
          font-size: 0;
          vertical-align: middle;
        }
      }
      .text {
        font-size: 14px;
        color: #fff;
      }
    }
  }
</style>
<script>
  import {Toast} from 'mint-ui'
  import {IsWeiXin} from '../../common/js/isWeixin'

  export default {
    data() {
      return {
        ordinaryShow: {
          type: Boolean // 普通浏览器
        },
        weixinShow: {
          type: Boolean // 微信浏览器
        }
      }
    },
    created() {
      // 判断是否是微信浏览器
      if (IsWeiXin()) {
        this.ordinaryShow = false
        this.weixinShow = true
      } else {
        this.ordinaryShow = true
        this.weixinShow = false
      }
    },
    methods: {
      goDetail(e) {
        this.$emit('detail', e.target)
      },
      // goPublish (e) {
      //   this.$emit('publish', e.target)
      // },
      goChose(e) {
        this.$emit('city', e.target)
      },
      // goRepairsPublish (e) {
      //   this.$emit('repairsPublish', e.target)
      // },
      // goUnusedPublish (e) {
      //   this.$emit('unusedPublish', e.target)
      // },
      goHousePublish(e) {
        this.$emit('housePublish', e.target)
      },
      gogoodsPublish(e) {
        this.$emit('goodsPublish', e.target)
      },
      gohelpPublish(e) {
        this.$emit('helpPublish', e.target)
      },
      // goseekPublish (e) {
      //   this.$emit('seekPublish', e.target)
      // },
      gorepairPublish(e) {
        this.$emit('repairPublish', e.target)
      },
      gotopicPublish(e) {
        this.$emit('topicPublish', e.target)
      },
      // goRelease (e) {
      //   this.$emit('release', e.target)
      // },
      gotoRelease(e) {
        this.$emit('torelease', e.target)
      },
      goTeamlist(e) {
        this.$emit('teamlist', e.target)
      },
      // 查验发布的点击事件判断
      goCheck(e) {
        if (IsWeiXin()) {
          this.$emit('toCheck', e.target)
        } else {
          Toast({
            message: '请在业主在线微信公众号里打开',
            position: 'middle',
            duration: 3000
          })
        }
      },
      goHousePub(e) {
        this.$emit('toHousePub', e.target)
      },
      goCheckPublish(e) {
        this.$emit('checkPublish', e.target)
      },
      goReCheckPublish(e) {
        this.$emit('reCheckPublish', e.target)
      },
      goPublishAllCheck(e) {
        this.$emit('publishAllCheck', e.target)
      },
      goEditAllCheck(e) {
        this.$emit('editAllCheck', e.target)
      },
      // 普通浏览器的点击
      goDinary() {
        Toast({
          message: '请在业主在线微信公众号里打开',
          position: 'middle',
          duration: 3000
        })
      }
    },
    props: [
      'headTitle',
      'goBack',
      'hidden',
      'rightTitle',
      'btnSubmit',
      'publish',
      'unusedPublish',
      'choseCity',
      'repairsPublish',
      'housePublish',
      'goodsPublish',
      'helpPublish',
      'seekPublish',
      'repairPublish',
      'topicPublish',
      'release',
      'torelease',
      'teamlist',
      'check',
      'housePub',
      'checkPublish',
      'recheckPublish',
      'publishAllCheck',
      'editCheck'
    ]
  }
</script>



// WEBPACK FOOTER //
// src/components/header/Header.vue